(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STAR_PATH =
      'M12 2.5l2.9 6.2 6.6.7-4.9 4.6 1.4 6.6L12 17.3l-5.9 3.3 1.4-6.6L2.6 9.4l6.6-.7z';

    function stars(rating) {
      let html = '';
      for (let i = 1; i <= 5; i++) {
        const cls = i <= Math.round(rating) ? '' : ' class="google-reviews__star--empty"';
        html += `<svg${cls} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="${STAR_PATH}"/></svg>`;
      }
      return html;
    }

    function setupDots(list) {
      const section = list.closest('.google-reviews');
      const dotsWrap = section && section.querySelector('[data-google-reviews-dots]');
      if (!dotsWrap) return;

      if (list._grCleanup) list._grCleanup();

      const cards = Array.from(list.children);
      let dots = [];
      let perView = 1;
      let slideCount = 1;

      // One dot per slide: a slide is however many cards fit the list's width.
      const measure = () => {
        const step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : list.clientWidth;
        perView = Math.max(1, Math.round((list.clientWidth + 1) / (step || 1)));
        slideCount = Math.max(1, Math.ceil(cards.length / perView));
      };

      const maxScroll = () => list.scrollWidth - list.clientWidth;

      const currentSlide = () => {
        if (list.scrollLeft >= maxScroll() - 2) return slideCount - 1;
        let active = 0;
        let best = Infinity;
        for (let i = 0; i < slideCount; i++) {
          const card = cards[i * perView];
          const distance = Math.abs(card.offsetLeft - cards[0].offsetLeft - list.scrollLeft);
          if (distance < best) {
            best = distance;
            active = i;
          }
        }
        return active;
      };

      const goTo = (slide) => {
        const card = cards[Math.min(slide * perView, cards.length - 1)];
        const left = Math.min(card.offsetLeft - cards[0].offsetLeft, maxScroll());
        list.scrollTo({ left, behavior: 'smooth' });
      };

      const update = () => {
        const active = currentSlide();
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === active);
          if (i === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };

      const buildDots = () => {
        measure();
        dotsWrap.replaceChildren();
        dots = [];
        if (slideCount < 2) return;
        for (let i = 0; i < slideCount; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'google-reviews__dot';
          dot.setAttribute('aria-label', `Show slide ${i + 1} of ${slideCount}`);
          dot.addEventListener('click', () => goTo(i));
          dotsWrap.appendChild(dot);
          dots.push(dot);
        }
        update();
      };

      let frame;
      const onScroll = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      };
      list.addEventListener('scroll', onScroll, { passive: true });

      let lastWidth = list.clientWidth;
      const resizeObserver = new ResizeObserver(() => {
        if (list.clientWidth === lastWidth) return;
        lastWidth = list.clientWidth;
        buildDots();
      });
      resizeObserver.observe(list);

      // Autoplay: next slide every N seconds, looping. Paused while hovered or focused,
      // while the tab is hidden, and for visitors who prefer reduced motion.
      const delay = Number(list.dataset.autoplay) || 0;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let timer = null;
      let hovered = false;
      let focused = false;

      const stop = () => {
        clearInterval(timer);
        timer = null;
      };
      const start = () => {
        stop();
        if (!delay || reducedMotion || hovered || focused || document.hidden || slideCount < 2) return;
        timer = setInterval(() => {
          const next = currentSlide() + 1;
          goTo(next >= slideCount ? 0 : next);
        }, delay);
      };

      const onEnter = () => { hovered = true; stop(); };
      const onLeave = () => { hovered = false; start(); };
      const onFocusIn = () => { focused = true; stop(); };
      const onFocusOut = (event) => {
        if (section.contains(event.relatedTarget)) return;
        focused = false;
        start();
      };
      const onVisibility = () => (document.hidden ? stop() : start());

      section.addEventListener('mouseenter', onEnter);
      section.addEventListener('mouseleave', onLeave);
      section.addEventListener('focusin', onFocusIn);
      section.addEventListener('focusout', onFocusOut);
      document.addEventListener('visibilitychange', onVisibility);

      list._grCleanup = () => {
        stop();
        resizeObserver.disconnect();
        list.removeEventListener('scroll', onScroll);
        section.removeEventListener('mouseenter', onEnter);
        section.removeEventListener('mouseleave', onLeave);
        section.removeEventListener('focusin', onFocusIn);
        section.removeEventListener('focusout', onFocusOut);
        document.removeEventListener('visibilitychange', onVisibility);
      };

      buildDots();
      start();
    }

    async function load(list) {
      const section = list.closest('.shopify-section');
      const template = section && section.querySelector('template[id^="google-reviews-template-"]');
      if (!template) return;

      try {
        const response = await fetch(
          `https://places.googleapis.com/v1/places/${encodeURIComponent(list.dataset.placeId)}`,
          {
            headers: {
              'X-Goog-Api-Key': list.dataset.apiKey,
              'X-Goog-FieldMask': 'reviews',
            },
          }
        );
        if (!response.ok) throw new Error(`Google Places responded ${response.status}`);

        const data = await response.json();
        const minRating = Number(list.dataset.minRating) || 1;
        const reviews = (data.reviews || [])
          .filter((review) => review.rating >= minRating && review.text && review.text.text)
          .slice(0, Number(list.dataset.max) || 3);
        if (!reviews.length) return;

        const fragment = document.createDocumentFragment();
        reviews.forEach((review) => {
          const card = template.content.cloneNode(true);
          const author = review.authorAttribution || {};
          const stars_el = card.querySelector('[data-stars]');
          stars_el.innerHTML = stars(review.rating);
          stars_el.setAttribute('aria-label', `${review.rating} out of 5 stars`);
          card.querySelector('[data-text]').textContent = review.text.text;
          card.querySelector('[data-name]').textContent = author.displayName || '';
          card.querySelector('[data-subtitle]').textContent = review.relativePublishTimeDescription || '';

          const avatar = card.querySelector('[data-avatar]');
          if (author.photoUri) {
            const img = document.createElement('img');
            img.src = author.photoUri;
            img.alt = author.displayName || '';
            img.loading = 'lazy';
            img.referrerPolicy = 'no-referrer';
            avatar.appendChild(img);
          } else {
            const initial = document.createElement('span');
            initial.className = 'google-reviews__initial';
            initial.textContent = (author.displayName || '?').charAt(0);
            avatar.appendChild(initial);
          }
          fragment.appendChild(card);
        });

        list.replaceChildren(fragment);
        setupDots(list);
      } catch (error) {
        console.warn('[google-reviews] Keeping placeholder reviews:', error);
      }
    }

    function init(root) {
      root.querySelectorAll('.google-reviews__list').forEach(setupDots);
      root.querySelectorAll('[data-google-reviews]').forEach(load);
    }

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.google-reviews__list').forEach((list) => list._grCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reading-types"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(slider) {
      if (slider.dataset.sliderReady) return;
      slider.dataset.sliderReady = 'true';

      const section = slider.closest('.reading-types');
      const dots = section ? Array.from(section.querySelectorAll('.reading-types__dot')) : [];
      const cards = Array.from(slider.children);
      if (!dots.length) return;

      function setActive(index) {
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === index);
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function nearestIndex() {
        const center = slider.scrollLeft + slider.clientWidth / 2;
        let best = 0;
        let bestDistance = Infinity;
        cards.forEach((card, i) => {
          const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - center);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        });
        return best;
      }

      let frame;
      slider.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => setActive(nearestIndex()));
        },
        { passive: true }
      );

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const card = cards[i];
          if (!card) return;
          slider.scrollTo({
            left: card.offsetLeft - (slider.clientWidth - card.offsetWidth) / 2,
            behavior: 'smooth',
          });
          setActive(i);
        });
      });
    }

    function init(root) {
      root.querySelectorAll('[data-reading-types-slider]').forEach(initSlider);
    }

    init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
